import React from 'react';
import { useApplicationContext } from 'shared/utils/applicationContext';
import { getIsCpcAuction } from 'shared/utils/auction';
import { isNotSearcher } from 'shared/utils/isNotSearcher';

import { VasList } from '../../../../components/VasList';
import { useOfferContext } from '../../../../context';
import { useAuctionContext } from '../../../../context/AuctionContext';
import { AuctionApplyNewBetHintContainer } from '../AuctionApplyNewBetHintContainer';

export function VASListContainer() {
  const { config } = useApplicationContext();
  const { user, vasList, isFromSuburbanBuilder, offer } = useOfferContext();
  const { currentBet, liquidityPoints } = useAuctionContext();
  const isPerformanceVasPilot = !!config.get<boolean>('isPerformanceVASPilot.Enabled');

  /**
   * @todo: удалить в задаче CD-260866
   */
  const isCpcAuctionEnabled = !!config.get<boolean>('auction.cpcEnabled');

  /**
   * Для оффера с CPC аукционом не показываем продвижение
   */
  const isCpcOffer = isCpcAuctionEnabled && getIsCpcAuction(offer);

  if (!isNotSearcher(user) || isFromSuburbanBuilder || vasList.length === 0 || isPerformanceVasPilot || isCpcOffer) {
    return null;
  }

  return (
    <VasList
      items={vasList}
      bet={currentBet}
      liquidityPoints={liquidityPoints}
      nextBetTip={<AuctionApplyNewBetHintContainer />}
    />
  );
}
